// extracted by mini-css-extract-plugin
export var banner = "_jy-0";
export var settingRow = "_jy-2";
export var titleIcon = "_jy-1";